module.exports = "/images/map.png?1372e94a221ec7fded01aeba2d23466d";